import React from 'react'

import EventFormPriceFieldModule from 'components/Events/EventForm/EventFormModules/EventFormPriceFieldModule/EventFormPriceFieldModule'

const EventFormIncomeModule = ({ label }) => {
    return (
        <EventFormPriceFieldModule
            className="event-form-income-module"
            name="income"
            label={label}
            unitsTip="€"
            icon="euro-sign"
        />
    )
}

export default EventFormIncomeModule
